module.exports = __webpack_public_path__ + "static/media/Step3-n.9a115f06.png";